<script>
import Items from '../stores/Items.js';

import { fly, scale, slide } from 'svelte/transition';
import {flip} from 'svelte/animate';

import Fa from 'svelte-fa';
import { faCheck, faRedo, faTrashAlt, faChevronRight } from '@fortawesome/free-solid-svg-icons';

// ----------------------------------------------- //


// toggling of todo/redo status
const toggleStatus = (id) => { 
	Items.update(currentItems => {
		let editTodo = currentItems.find(item => item.id === id);
		editTodo.done = !editTodo.done;
		
		// repositioning within the list (redos go last)
		if (editTodo.done) {
			currentItems.push(currentItems.splice(currentItems.indexOf(editTodo), 1)[0]);
		} else {
			currentItems.unshift(currentItems.splice(currentItems.indexOf(editTodo), 1)[0]);
		};
		// let's reflect the changes in ItemStore
		return currentItems;
	})
}

// removing a specific item
const removeTodo = (todo) => {
	Items.update(currentItems =>{
			return currentItems = currentItems.filter(t => t.id !== todo.id);
	})
}

// handling the editing of items inline
const handleEdit = (e) => {
	if (e.keyCode === 13) {
		e.preventDefault;
		e.target.blur();
		Items.update(currentItems =>{
			return currentItems;
		})
	};
}

let openStyle = "transform: rotate(90deg); transform-origin: center center;";

const openTodo = (todo) => {
	todo.isOpen = !todo.isOpen;
	Items.update(currentItems =>{
			return currentItems;
		})
}

</script>


<ul id="todolist">
	{#each $Items as todo(todo.id)}
	<li class:done={todo.done} in:slide|local={{y: 50, duration: 350}} out:scale|local animate:flip={{duration: 400}}>
		<div class="button-holder">
			<button class={'btn-action btn-info'} on:click={() => openTodo(todo)}><Fa icon={faChevronRight} style='{todo.isOpen ? openStyle : ""} transition: transform 300ms linear'/></button>
			<p class="todo-title" contenteditable="true" bind:textContent={todo.title} on:keydown={handleEdit} on:blur={handleEdit}>
				{todo.title}
			</p>
		</div>
		<div class="button-holder">

			<button class="btn-action btn-done" on:click={() => toggleStatus(todo.id)}><Fa icon={todo.done ? faRedo : faCheck}/></button>

			<button class="btn-action btn-delete" on:click={() => removeTodo(todo)}><Fa icon={faTrashAlt} /></button>
			
		</div>

		<div class="details-view" style={todo.isOpen ? 'display: flex;' : 'display: none;'} >

			<div class="space-group">
				<div class="detail-wrap">
					<label for="location" class="location">Location: </label> 
					<input class="detail-input" id="location" type="text" bind:value={todo.location}>
					</div>
					
					<div class="detail-wrap">
					<label for="starts" class="starts">Starts: </label>
					<input class="detail-input" id="starts" type="datetime-local" bind:value={todo.starts}>
					</div>
		
					<div class="detail-wrap">
					<label for="ends" class="ends">Ends: </label>
					<input class="detail-input" id="ends" type="datetime-local" bind:value={todo.ends}>
					</div>
			</div>
		
			<div class="detail-wrap-full">
			<label for="notes" class="notes">Notes: </label>
			<textarea class="detail-input" id="notes" type="text" rows="5" bind:value={todo.notes}/>
		</div>
		</div>
	</li>
	{:else}
	<p class="empty__placeholder">Type in your first item above</p>
	{/each}
</ul>

<!-- THE CSS -->

<style>
	#todolist{
		width: auto;
	}
	#todolist li{
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		overflow-y: hidden;
		width: 100%;
		background-color: var(--primary-clr);
		border-radius: 5px;
		margin: 1rem auto;
		box-shadow: var(--box-shadow);
		transition: transform 200ms ease-in-out;
	}

	p{
		text-align: left;
		font-size: var(--font-size-items);
		background-color: inherit;
		color: var(--contrast-clr-1);
		padding: 0.7rem;
		border-radius: 5px 0 0 5px;
		font-weight: normal;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		word-wrap: normal;
	}
	p[contenteditable] {
  		outline: 0px solid transparent;
	}

	.button-holder{
		display: inline-flex;
		width: auto;
	}

	.btn-action{
		padding: 0.8rem;
		color: var(--white);
		cursor: pointer;
		height: 100%;
	}
	.btn-done{
		color: var(--contrast-clr-1);
		background-color: inherit;
	}

	.btn-delete{
		color: var(--contrast-clr-2);
		background-color: inherit;
		/* border-radius: 0 5px 5px 0; */
	}

	.btn-info{
		color: var(--contrast-clr-1);
		background-color: inherit;
	}

	#todolist li.done{
		text-decoration: line-through;
		opacity: 0.3;
		border: none;
		box-shadow: none;
	}

	@media (hover: hover) {
		.btn-done:hover{
			color: var(--black);
			background-color: var(--contrast-clr-1);
		}
		.btn-delete:hover{
			color: var(--black);
			background-color: var(--contrast-clr-2);
		}
		.btn-info:hover{
			color: var(--black);
			background-color: var(--contrast-clr-1);
		}
	}

	.details-view{
		display: none; /* flex */
		flex-wrap: wrap;
		width: 100%;
		align-self: stretch;
		padding: 2rem 0.7rem;
		border-top: 1px solid var(--contrast-clr-1);
	}


	label{
		font-size: 0.9rem;
		font-weight: normal;
		color: var(--contrast-clr-1);
		padding-bottom: 0.3rem;
		margin-right: 0.7rem;
	}
	label.notes{
		display: block;
	}
	.space-group{
		width: 100%;
		display: flex;
		justify-content: space-between;
		margin-bottom: 1.7rem;
	}
	.detail-wrap, .detail-wrap-full{
		display: inline-block;
		text-align: left;
	}
	.detail-wrap-full, .detail-input#notes{
		width: 100%;
	}
	.detail-input{
		color: var(--contrast-clr-1);
		background-color: var(--secondary-clr);
		padding: 4px;
		border-radius: 5px;
	}
	.detail-input:focus, .detail-input#notes:focus{
		outline: 1px solid var(--contrast-clr-1);
	}

	input[type="datetime-local"]::-webkit-calendar-picker-indicator {
		opacity: 0.75;
		background-image: url(images/picker.svg);
	}

	.empty__placeholder{
		text-align: center;
		font-style: italic;
		opacity: 0.4;
	}
	
</style>